import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { DataMap } from '@grapecity/wijmo.grid'

import { JobOwnership, ListItem, RepositoryModal } from '../../shared'
import { VoiceTextFieldComponent } from '../../shared/components/voice-text-field/voice-text-field.component'

@Component({
    templateUrl: './job-ownership.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent, VoiceTextFieldComponent],
})
export class JobOwnershipComponent extends RepositoryModal<JobOwnership> {
    userMap: ListItem<number>[] = []
    statusMap: ListItem<number>[] = [new ListItem(0, 'On Track'), new ListItem(1, 'Off Track'), new ListItem(2, 'Done')]
    isStatusBound = false

    protected onInitialized() {
        const dm = this.editOptions.initializeParams.activeUserMap as DataMap
        this.userMap = dm.collectionView.items.map(x => new ListItem(x.id, x.name))
    }

    statusBound() {
        setTimeout(() => (this.isStatusBound = true), 100)
    }

    updateDoneDate() {
        if (this.target.status === 2 && !this.target.doneDate && this.isStatusBound) {
            this.target.doneDate = new Date()
        }
    }

    onBeforeSave() {
        if (this.isAdding) {
            this.target.job = this.editOptions.initializeParams.selectedJob()
            this.target.order = this.editOptions.initializeParams.grid.view.items.length
        }
        return true
    }
}
